module.exports = __webpack_public_path__ + "img/StaffStyle4.9d7d859e.jpg";